import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreateDmxControllerForm from '../../components/Forms/CreateDmxControllerForm';

class NewDmxController extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.push('/dmxControllers');
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreateDmxControllerForm />
        </Container>
      </div>
    );
  }
}

export default NewDmxController;
